$(document).on('click', '.card-checklist .btn-checklist-quickview',function() {
    var parent = $(this).parent().closest('.card-checklist');

    var checklist_title = $('.card-checklist--header .title a', parent).text().trim();
    var checklist_url = $(this).attr('data-url').trim();
    var checklist_user = $('.card-checklist--header .user', parent).text();
    var checklist_desc = $('.card-checklist--desc p', parent).text();
    var checklist_status_text = $('.complete-status--text', parent).text();
    var checklist_status_bar = $('.complete-status--line', parent).attr('style');
    var copy_url = $('.btn-copy', parent).attr('onclick');
    var like_count = $('.like-count', parent).text();
    if($('.card-checklist--top', parent).length){
        console.log('hi exists');
        $('#lightbox-checklist-quickview .card-checklist .card-checklist--top').addClass('d-flex');
        $('#lightbox-checklist-quickview .card-checklist .card-checklist--top').removeClass('d-block');
    } else {
        console.log('hi no exists');
        $('#lightbox-checklist-quickview .card-checklist .card-checklist--top').removeClass('d-flex');
        $('#lightbox-checklist-quickview .card-checklist .card-checklist--top').addClass('d-none');
    };
    $('#lightbox-checklist-quickview .card-checklist--content .list-check-action').remove();
    $(".card-checklist--content .list-check-action", parent).clone().appendTo("#lightbox-checklist-quickview .card-checklist--content");

    $('#lightbox-checklist-quickview .card-checklist--header .title a').text(checklist_title);
    $('#lightbox-checklist-quickview .card-checklist--header .title a').attr('href', checklist_url);
    $('#lightbox-checklist-quickview .card-checklist--header .user').text(checklist_user);
    $('#lightbox-checklist-quickview .card-checklist--desc p').text(checklist_desc);
    $('#lightbox-checklist-quickview .complete-status--text').text(checklist_status_text);
    $('#lightbox-checklist-quickview .complete-status--line').attr('style', checklist_status_bar);
    $('#lightbox-checklist-quickview .btn-checklist-share-mobile').attr('onclick', 'navigator.share({title: "' + checklist_title + '",url: "' + checklist_url + '"});');
    $('#lightbox-checklist-quickview .btn-copy').attr('onclick', copy_url);
    $('#lightbox-checklist-quickview .like-count').text(like_count);


    var checklist_bottom = $(this).parent().next('.card-checklist--bottom');
    if($('.card-checklist--btn-like', checklist_bottom ).hasClass('active')){
        $('#lightbox-checklist-quickview .btn-like').addClass('active');
    }else{
        $('#lightbox-checklist-quickview .btn-like').removeClass('active');
    }

    var currentForm = $('.card-checklist--btn-like', checklist_bottom ).parents('form:first');
    var checklist_id =  $("input[name='checklist-item-id']", currentForm).val()
    $('#lightbox-checklist-quickview .btn-like').data('checklist', checklist_id);

})

$(document).on('click', '#lightbox-checklist-quickview .btn-like',function(e){
    e.preventDefault();
    var button = $(this).prop('disabled', true);
    var checklist_id = $(this).data('checklist')
    var currentForm = $(`form[id="single-checklist-item-form-${checklist_id}"]`)

    // if (isUserLoggedIn) {
    //     $(this).toggleClass('active')
    //     $('.card-checklist--btn-like', currentForm).toggleClass('active');
    // }
    
    $(this).toggleClass('active')
    $('.card-checklist--btn-like', currentForm).toggleClass('active');
    

    $.ajax({
        type: 'POST',
        url: page_ajax.wp_ajax_file,
        dataType: 'json',
        data: {
            action: 'checkLikes',
            post_id: checklist_id,
        },
        success: function(Response) {
            console.log('success');
            console.table(Response);

            if (Response.like_count >= 1 && isUserLoggedIn === true) {
                $('#lightbox-checklist-quickview .like-count').text((Response.like_count > 1) ? `${Response.like_count} Likes` : `${Response.like_count} Like`)
                currentForm.find('span').text((Response.like_count > 1) ? `${Response.like_count} Likes` : `${Response.like_count} Like`)
            } 
            else if (Response.like_count < 1 && isUserLoggedIn === true) {
                $('#lightbox-checklist-quickview .like-count').text('Like')
                currentForm.find('span').text('Like')
            };
        },
        complete: function(){
            button.prop('disabled', false);
        }
    });
})